import { use_slice_generation } from '@/hooks/store/use_slices';
import { HOOK_IMAGE__get_image_mask_for } from '@/utils/_methods/FN_IMAGE__get_image_mask_for';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__image_crop_box } from '@shared/dto/+image/image_asset_base/DTO__image_crop_box';
import { ENUM_UTILS__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__image_transform } from '@shared/dto/generation/graph_invoke/_fields/image/_enums/ENUM__image_transform';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/ENUM__invocation_type';
import { INVOCATION_IMAGE__viewport } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__viewport';
import { ENUM__position_9 } from '@shared/enums/ENUM__position_9';
import { LABEL__image_info } from './LABEL__image_info';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_GRAPH__IMAGE__labels({ field }: PROPS) {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  let field_image_mask = HOOK_IMAGE__get_image_mask_for(field);

  let { graph } = generation_current.tool;

  /*
   * METHODS
   */
  function get_text__color_mode() {
    return field.asset.color_mode;
  }

  function get_text__image_category() {
    return field.category;
  }
  function get_text__image_size() {
    let image_size = field.asset.image_size;

    let parts = [image_size.toString()];

    try_add_part__scale(parts);
    try_add_part__crop(parts);

    if (parts.length > 1) {
      parts[0] = `original:\t${image_size.toString()}`;
    }

    let out = parts.join('\n');

    return out;
  }

  function try_add_part__scale(parts: string[]) {
    let { preprocessing_transform__current } = field;

    if (preprocessing_transform__current == ENUM__image_transform.NONE) return;

    let { grid2d_cell__aspect_ratio } = graph.invocation_grid2d_view;

    let image_size_original = field.asset.image_size;

    let image_size = ENUM_UTILS__ml_asset_family.get_image_size_scaled(field.meta.node_family, grid2d_cell__aspect_ratio);

    if (image_size_original.is_equal(image_size)) return;

    parts.push(`scale:\t\t${image_size.toString()}`);
  }

  function try_add_part__crop(parts: string[]) {
    let crop_box = get_image_crop_box();

    let image_size_original = field.asset.image_size;

    if (field.meta.kind__is_output) return; //we dont apply crop box to output
    if (crop_box.is_stub()) return;
    if (crop_box.is_cover_image_size(image_size_original.width, image_size_original.height)) return;
    if (crop_box.is_zero()) return;

    parts.push(`crop:\t\t${crop_box.size.toString()}`);
  }

  function get_image_crop_box() {
    let out = DTO__image_crop_box.CREATE_STUB();

    if (field.meta.node_type == ENUM__invocation_type.IMAGE__VIEWPORT) {
      let node = graph.node__get(field.meta.node_id);
      assert_instanceof(node, INVOCATION_IMAGE__viewport);

      out = node.crop_box.crop_box.clone();
    }

    return out;
  }

  /*
   * HTML
   */

  if (!field.image__is_initialized) return null;

  return (
    <div className="absolute inset-0 pointer-events-none">
      <LABEL__image_info text={get_text__color_mode()} position={ENUM__position_9.TOP_RIGHT} />
      <LABEL__image_info text={get_text__image_size()} position={ENUM__position_9.TOP_LEFT} />
      <LABEL__image_info text={field_image_mask.get_text__mask()} position={ENUM__position_9.BOTTOM_LEFT} />
      <LABEL__image_info text={get_text__image_category()} position={ENUM__position_9.BOTTOM_RIGHT} />
    </div>
  );
}
